/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import LayoutOperation from "../../components/layout_operation";
import axios from "axios";
import { DownOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Dropdown,
  Menu,
  Select,
  Radio,
  Upload,
  Button,
  message,
  Checkbox,
  Table,
  Badge,
  DatePicker,
  Drawer,
  Modal,
  Input,
  AutoComplete,
} from "antd";
// import Map from "../../ui/map_full_detail";

import DynamicInput from "../../services/ui/dynamic_input";
import reqwest from "reqwest";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import moment from "moment";
import ModalSuccess from "../../components/Modal_Success";
import ServiceApi from "../../services/ServiceApi";
import { changeLang } from "../../actions/langAction";
import { setDynamic } from "../../actions/dynamicAction";

const { Search } = Input;
const menu = (
  <Menu>
    <Menu.Item>Action 1</Menu.Item>
    <Menu.Item>Action 2</Menu.Item>
  </Menu>
);
// const { Option } = Select;
const { RangePicker } = DatePicker;
class Addjob extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      period_start: [],
      period_end: [],
      loading: true,
      title: "ADD JOB",
      statusbtn: 2,
      showMenu: false,
      job_type: [],
      sub_type: [],
      get_preiod: [],
      active: 0,
      startDate: new Date(),
      DateTime_Install: new Date(),
      Assign_date: new Date(),
      options: [],
      team_list: [],
      fileList: [],
      fileShow: [],
      uploading: false,
      jobcategory: "",
      ckTeam: false,
      ckSingle: false,
      ckasset: false,
      form: {},
      Priority: 1,
      modalstatus: false,
      set_asset: [],
      asset_name: "-",
      group_type: "-",
      asset_type: "-",
      ass_sub_type: "-",
      modal_number: "-",
      serial_number: "-",
      date_install: "-",
      warranty: "-",
      asset_ma: "-",
      ass_lat: "-",
      ass_long: "-",
      ass_name: "-",
      ass_code: "-",
      smart_code: "-",
      ckpm: false,
      ckcm: false,
      status_cookie: 0,
      setStartDate: new Date(),
      columns_jobs: [
        { title: "Date", dataIndex: "date", key: "date" },
        { title: "Name", dataIndex: "name", key: "name" },
        {
          title: "Status",
          key: "state",
          render: () => (
            <span>
              <Badge status="success" />
              Finished
            </span>
          ),
        },
        { title: "Upgrade Status", dataIndex: "upgradeNum", key: "upgradeNum" },
        {
          title: "Action",
          dataIndex: "operation",
          key: "operation",
          render: () => (
            <span className="table-operation">
              <button>Pause</button>
              <button>Stop</button>
              <Dropdown overlay={menu}>
                <button>
                  More <DownOutlined />
                </button>
              </Dropdown>
            </span>
          ),
        },
      ],
      columns_job_history: [
        {
          title: "Job no",
          dataIndex: "job_no",
          key: "job_no",
          sorter: (a, b) => a.job_no.length - b.job_no.length,
        },
        {
          title: "Asset id",
          dataIndex: "asset_id",
          key: "asset_id",
          render: (item) => {
            return (!item  ? "-" :  item)
          },
          sorter: (a, b) => a.asset_id.length - b.asset_id.length,
        },
        {
          title: "Emp Inform Date",
          dataIndex: "emp_inform_date",
          key: "emp_inform_date",
          render: (item) => {
              return !item
                ? "-"
                : moment(item).format("DD/MM/YYYY HH:mm");
          },
          sorter: (a, b) => a.emp_inform_date.length - b.emp_inform_date.length,
        },
        {
          title: "Inform Detail",
          dataIndex: "inform_detail",
          key: "inform_detail",
          render: (item) => {
            return (!item  ? "-" :  item)
          },
          sorter: (a, b) => a.inform_detail.length - b.inform_detail.length,
        },
        {
          title: "From Main Process Name",
          dataIndex: "from_main_process_name",
          key: "from_main_process_name",
          render: (item) => {
            return (!item  ? "-" :  item)
          },
          sorter: (a, b) => a.from_main_process_name.length - b.from_main_process_name.length,
        },
        {
          title: "Finish Date",
          dataIndex: "finish_date",
          key: "finish_date",
          render: (item) => {
            return !item
            ? "-"
            : moment(item).format("DD/MM/YYYY HH:mm");
          },
          sorter: (a, b) => a.asset_code.length - b.asset_code.length,
        },
      ],
      data_jobs: [],
      job_cat: [],
      visibleView: false,
      dataModuleName: [],
      valueModuleName: "",
      dataTableName: [],
      valueTableName: "",
      dataMasterLanguage: [],
      valueMasterLanguage: [
        { children: ["English", " (", "EN", ")"], key: "EN", value: "English" },
      ],
      rulesOpt: [],
      disOpt: [],
      disBtn: true,
      disInput: true,
      dataColumnName: [],
      dataMasFormJson_Call: {},
      mode: "add",
      dataAdd: {
        condition: [{ key: 0, fieldKey: 0, name: 0 }],
        forms: [{ key: 0, fieldKey: 0, name: 0 }],
        language: ["English"],
      },
      data_dynamic_from: [],
      department_id: 0,
      id_form: 0,
      more_detail: false,
      selected_jobtype: null,
      selected_subtype: null,
      WorkFlow: {},
      factupdate: false,
      data_translate: [],
      label_translate: [],
      ObjectPart: [],
      serviceType: [],
      newType: [],
      subCategory: [],
      sla_level: [],
      previewVisible: false,
      previewImage: "",
      previewTitle: "",
      checkbtn: false,
      workflow_id: 0,
      sla_id: "",
      std_hour: "",
      std_day: "",
      std_minute: "",
      sel_type: null,
      sel_new_type: null,
      sel_sub_cat: null,
      sel_sla: null,
      customs: {
        select_object_path: null,
        select_sel_type: null,
        select_new_type: null,
        select_sub_category: null,
      },
      valid_asset: false,
      valid_obj_part: false,
      valid_service_type: false,
      valid_new_type: false,
      valid_sub_cat: false,
      modal_validate: false,
      valid: false,
      inform_name: Cookies.get("username"),
      urlpath: "",
      visible_addasset: false,
      status_button_workflow: "",
      columns_asset: [
        {
          title: (
            <Checkbox onChange={() => this.CheckboxAsset("all")}></Checkbox>
          ),
          dataIndex: "",
          key: "",
          render: (item) => (
            <Checkbox
              onChange={() => this.CheckboxAsset(item)}
              checked={item["status_checkbox"]}
            ></Checkbox>
          ),

          // sorter: () => null,
        },
        // {
        //   title: "Asset Id",
        //   dataIndex: "asset_id",
        //   key: "asset_id",
        //   sorter: () => null,
        // },
        {
          title: "Asset Code",
          dataIndex: "asset_code",
          key: "asset_code",
          sorter: (a, b) => a.asset_code.length - b.asset_code.length,
        },
        {
          title: "Asset Name",
          dataIndex: "asset_name",
          key: "asset_name",
          sorter: (a, b) => a.asset_name.length - b.asset_name.length,
        },
        {
          title: "Group Type",
          dataIndex: "group_type_name",
          key: "group_type_name",
          sorter: (a, b) => a.group_type_name.length - b.group_type_name.length,
        },
        {
          title: "Asset Type",
          dataIndex: "asset_type_name",
          key: "asset_type_name",
          sorter: (a, b) => a.asset_type_name.length - b.asset_type_name.length,
        },
        // {
        //   title: "Serial no.",
        //   dataIndex: "",
        //   key: "",
        //   // sorter: (a, b) => a.asset_type_name.length - b.asset_type_name.length,
        // },
        // {
        //   title: "Action",
        //   dataIndex: "",
        //   key: "",
        //   render: (item) => (
        //     <>
        //        <a href="#" onClick={() =>  this.Addaset(item)}>
        //             <img src={ServiceApi.absoluteUrl("/icon/edit.svg")} />
        //         </a>
        //     </>
        //   )
        // },
      ],
      columns_asset_package: [
        {
          title: (
            <Checkbox onChange={() => this.CheckboxAsset("packall")}></Checkbox>
          ),
          dataIndex: "",
          key: "",
          render: (item) => (
            <Checkbox
              onChange={() => this.CheckboxAsset(item)}
              checked={item["status_checkbox"]}
            ></Checkbox>
          ),
        },

        {
          title: "Package Code",
          dataIndex: "part_num",
          key: "part_num",
          sorter: (a, b) => a.part_num.length - b.part_num.length,
        },
        {
          title: "Package Name",
          dataIndex: "part_desc",
          key: "part_desc",
          sorter: (a, b) => a.part_desc.length - b.part_desc.length,
        },
        {
          title: "Group Type",
          dataIndex: "group_type_name",
          key: "group_type_name",
          sorter: (a, b) => a.group_type_name.length - b.group_type_name.length,
        },
        {
          title: "Asset Type",
          dataIndex: "asset_type_name",
          key: "asset_type_name",
          sorter: (a, b) => a.asset_type_name.length - b.asset_type_name.length,
        },
        // {
        //   title: "Action",
        //   dataIndex: "",
        //   key: "",
        //   render: (item) => (
        //     <>
        //        <a href="#" onClick={() =>  this.Addaset(item)}>
        //             <img src={ServiceApi.absoluteUrl("/icon/edit.svg")} />
        //         </a>
        //     </>
        //   )
        // },
      ],
      columns_asset_list: [
        // {
        //   title: "Asset Id",
        //   dataIndex: "asset_id",
        //   key: "asset_id",
        //   sorter: () => null,
        // },
        {
          title: "Asset Code",
          dataIndex: "asset_code",
          key: "asset_code",
          sorter: (a, b) => a.asset_code.length - b.asset_code.length,
        },
        {
          title: "Asset Name",
          dataIndex: "asset_name",
          key: "asset_name",
          sorter: (a, b) => a.asset_name.length - b.asset_name.length,
        },
        {
          title: "Group Type",
          dataIndex: "group_type_name",
          key: "group_type_name",
          sorter: (a, b) => a.group_type_name.length - b.group_type_name.length,
        },
        {
          title: "Asset Type",
          dataIndex: "asset_type_name",
          key: "asset_type_name",
          sorter: (a, b) => a.asset_type_name.length - b.asset_type_name.length,
        },
        {
          title: "Location Name",
          dataIndex: "location_name",
          key: "location_name",
          sorter: (a, b) => a.location_name.length - b.location_name.length,
        },
        {
          title: "Location Lat",
          dataIndex: "location_lat",
          key: "location_lat",
          sorter: (a, b) => a.location_lat.length - b.location_lat.length,
        },
        {
          title: "Location Lon",
          dataIndex: "location_lon",
          key: "location_lon",
          sorter: (a, b) => a.location_lon.length - b.location_lon.length,
        },
        // {
        //   title: "Action",
        //   dataIndex: "",
        //   key: "",
        //   render: (item) => (
        //     <>
        //        <a href="#" onClick={() =>  console.log(item)}>
        //             <img src={ServiceApi.absoluteUrl("/icon/edit.svg")} />
        //         </a>
        //     </>
        //   )
        // },
      ],
      error_disPlay: [],
      company_id: Cookies.get("companyid"),
      shouldRenderDynamic: false,
      asset_select: [],
      master_asset: [],
      master_asset_package: [],
      set_select_asset: [],
      modal_type_asset: 0,
      data_package: [],
      checkAssetType: false,
      disabledAddAsset: false,
      checkboxAll: false,
      plan_date: "",
      asset_loading: false,
      asset_list: [],
      job_history : []
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }
  async componentDidMount() {
    document.title = "MaxiOperation - Add Job";
    this.setState({
      urlpath: process.env.REACT_APP_URL_API,
    });
    ServiceApi.get(
      "v2/get_cdi_new_smart",
      Cookies.get("companyid") + "/" + Cookies.get("operator_id") + "/"
    )
      .then((response) => {
        for (let i = 0; i < response.data.data["asset_Data"].length; i++) {
          response.data.data["asset_Data"][i]["status_checkbox"] = false;
          response.data.data["asset_Data"][i]["id"] = i;
        }
        this.setState({
          asset_select:
            response.data.data === null ? [] : response.data.data["asset_type"],
          set_asset:
            response.data.data === null ? [] : response.data.data["asset_Data"],
          data_asset:
            response.data.data === null ? [] : response.data.data["asset_Data"],
          master_asset:
            response.data.data === null ? [] : response.data.data["asset_Data"],
        });
      })
      .catch((e) => {
        console.log(e);
      });
    ServiceApi.post("get_job_category_V2", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_category_id: null,
      is_active: 1,
      date_active: null,
    })
      .then((response) => {
        this.setState({
          job_cat: response.data.data.result_data,
        });
      })
      .catch((e) => {
        console.log(e);
      });
    ServiceApi.post("get_ma_period", {
      pk_id: "",
      is_active: "1",
      effective: "",
      sql_where: " and company_id=" + Cookies.get("companyid"),
      //sql_where: "",
    })
      .then((response) => {
        this.setState({
          get_preiod: response.data.data.ma_preiod_dto_list,
        });
      })
      .catch((e) => {
        console.log(e);
      });
    ServiceApi.get("get_list_mas_form_json", "oper_job")
      .then((response) => {
        this.setState({
          data_dynamic_from: response.data.data.mas_form_json_dto_list,
        });
        // console.log(`dynamicform`, response.data.data.mas_form_json_dto_list); //Dr.CopyMan 23/11/2560
      })
      .catch((e) => {
        console.log(e);
      });

    ServiceApi.post("master_language_detail_get", {
      company_id: Cookies.get("companyid"),
      page_id: 1,
    })
      .then((response) => {
        this.setState({
          data_translate: JSON.parse(
            response.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
          ),
          factupdate: true,
        });
      })
      .catch((e) => {
        console.log(e);
      });
    if (this.state.factupdate) {
      if (Cookies.get("asset_id") == undefined) {
        this.setState({
          loading: false,
          status_cookie: 0,
        });
      } else {
        var setsmart = this.state.set_asset.find(
          (Element) => Element.id === Cookies.get("asset_id")
        );
        this.setState({
          loading: false,
          set_asset: [
            this.state.set_asset.find(
              (Element) => Element.id === Cookies.get("asset_id")
            ),
          ],
          smart_code: setsmart.asset_code,
          asset_name: setsmart.name,
          group_type: setsmart.group_type_id,
          asset_type: setsmart.asset_type_id,
          ass_sub_type: setsmart.asset_sub_type_id,
          modal_number: setsmart.model_no,
          serial_number: setsmart.serial_no,
          date_install: setsmart.datE_IMPORT,
          warranty: setsmart.warranty_expire,
          ass_lat: setsmart.location_lat,
          ass_long: setsmart.location_lon,
          ass_name: setsmart.name,
          ass_code: setsmart.asset_code,
          area_id: setsmart.area_id,
          asset_id: setsmart.asset_id,
          sub_area_id: setsmart.sub_area_id,
          status_cookie: 1,
          factupdate: true,
        });
        Cookies.remove("asset_id");
      }
    }
  }

  CheckboxAsset = (value) => {
    if (value === "all") {
      if (this.state.checkboxAll === false) {
        for (let i = 0; i < this.state.data_asset.length; i++) {
          this.state.data_asset[i]["status_checkbox"] = true;
        }
        this.setState({
          data_asset: this.state.data_asset,
          checkboxAll: true,
        });
      } else {
        for (let i = 0; i < this.state.data_asset.length; i++) {
          this.state.data_asset[i]["status_checkbox"] = false;
        }
        this.setState({
          data_asset: this.state.data_asset,
          checkboxAll: false,
        });
      }
    } else {
      value["status_checkbox"] = !value["status_checkbox"];
      this.setState({
        data_asset: this.state.data_asset,
      });
    }
  };

  btnImpofile() {
    this.setState({ statusbtn: true });
  }
  btnManual() {
    this.setState({ statusbtn: false });
  }
  async btnjobDetail(n) {
    ServiceApi.post("V4/get_job_type", {
      pk_id: null,
      fk_id: n,
      is_active: "1",
      effective: "1",
      sql_where: null,
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      UserName: Cookies.get("username"),
    })
      .then((response) => {
        this.setState({
          selected_jobtype: null,
          selected_subtype: null,
          sub_type: [],
          jobcategory: n,
          job_type: response.data.data,
          //set_asset: []
          customs: {
            select_object_path: null,
          },
          sel_type: null,
          sel_new_type: null,
          sel_sub_cat: null,
          ObjectPart: [],
          serviceType: [],
          newType: [],
          subCategory: [],
          sla_level: [],
          std_hour: "",
          std_day: "",
          std_minute: "",
          sla_id: "",
          sel_sla: null,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  ChangeAssetType = async (value) => {
    const { modal_type_asset } = this.state;
    await this.setState({ data_asset: [], asset_loading: true });
    if (modal_type_asset === 0) {
      if (value != undefined) {
        const tempFilteredData = this.state.master_asset.filter((o) =>
          Object.keys(o).some((k) =>
            String(o[k]).toLowerCase().includes(value.toLowerCase())
          )
        );
        console.log(tempFilteredData);
        this.setState({ data_asset: tempFilteredData, asset_loading: false });
      } else {
        this.setState({
          data_asset: this.state.master_asset,
          asset_loading: false,
        });
      }
    } else {
      if (value != undefined) {
        const tempFilteredData = this.state.master_asset_package.filter((o) =>
          Object.keys(o).some((k) =>
            String(o[k]).toLowerCase().includes(value.toLowerCase())
          )
        );
        console.log(tempFilteredData);
        this.setState({ data_asset: tempFilteredData, asset_loading: false });
      } else {
        this.setState({
          data_asset: this.state.master_asset_package,
          asset_loading: false,
        });
      }
    }
  };
  toggleDropdown() {
    this.setState({
      active: !this.state.active,
    });
  }
  onChange = (e) => {
    this.setState({
      Priority: e.target.value,
    });
  };
  onSelectJobType = (value) => {
    // let data_add = {
    //   jobType: value,
    // };
    this.state.jobtype = value;
  };
  checkboxTeam = (e) => {
    this.setState({
      ckTeam: e.target.checked,
      ckSingle: false,
    });
  };
  checkboxSingle = (e) => {
    this.setState({
      ckSingle: e.target.checked,
      ckTeam: false,
    });
  };
  checkAsset = (e) => {
    this.setState({
      ckasset: e.target.checked,
      disabledAddAsset: !e.target.checked,
      checkAssetType: true,
      asset_name: "-",
      group_type: "-",
      asset_type: "-",
      ass_sub_type: "-",
      modal_number: "-",
      serial_number: "-",
      date_install: "-",
      warranty: "-",
      asset_ma: "-",
      ass_lat: "",
      ass_long: "",
      ass_name: "",
      ass_code: "",
      asset_id: "",
      area_id: "",
      sub_area_id: "",
    });
    if(e.target.checked){
      this.loadDataJobHistory("-1");
      this.setState({
        asset_list : [] 
      })

    }else{
      this.setState({
        job_history : []
      })
    }

  };
  handleInputChange(event) {
    var name = event.target.name;
    var value = event.target.value;
    var form = this.state.form;

    if (name === "location_lat") {
      this.setState({
        ass_lat: value,
      });
    } else if (name === "location_lon") {
      this.setState({
        ass_long: value,
      });
    } else if (name === "location_name") {
      this.setState({
        ass_name: value,
      });
    }

    form[name] = value;
    this.setState(form);
  }
  async handleSelectChange(name, value) {
    console.log(name);
    console.log(value);
    var form = this.state.form;

    if (name === "ma_period_id") {
      const found = this.state.get_preiod.find(
        (element) => element.ma_period_id === value
      );

      form[name] = value;

      this.setState({
        period_start: moment(found.ma_time_start).format("HH:MM"),
        period_end: moment(found.ma_time_end).format("HH:MM"),
      });
      this.setState(form);
    } else {
      form[name] = value;
      this.setState(form);
    }
  }
  handleDateChange(name, value) {
    var form = this.state.form;

    if (name === "date_install") {
      form[name] = moment(value).format("YYYY-MM-DD");

      this.setState({ DateTime_Install: value });
      this.setState(form);
    } else {
      form[name] = moment(value).format("YYYY-MM-DD");
      this.setState({ Assign_date: value });
      this.setState(form);
    }
  }
  handleMultiChange = (data) => {
    var form = this.state.form;
    form["ma_period"] = data;
    this.setState(form);
  };
  NestedTable() {
    const expandedRowRender = () => {
      const columns = [
        { title: "Date", dataIndex: "date", key: "date" },
        { title: "Name", dataIndex: "name", key: "name" },
        {
          title: "Status",
          key: "state",
          render: () => (
            <span>
              <Badge status="success" />
              Finished
            </span>
          ),
        },
        { title: "Upgrade Status", dataIndex: "upgradeNum", key: "upgradeNum" },
        {
          title: "Action",
          dataIndex: "operation",
          key: "operation",
          render: () => (
            <span className="table-operation">
              <button className="c-blue text-underline">Pause</button>
              <button className="c-blue text-underline">Stop</button>
              <Dropdown overlay={menu}>
                <button className="c-blue text-underline">
                  More <DownOutlined />
                </button>
              </Dropdown>
            </span>
          ),
        },
      ];

      const data = [];
      for (let i = 0; i < 3; ++i) {
        data.push({
          key: i,
          date: "2014-12-24 23:12:00",
          name: "This is production name",
          upgradeNum: "Upgraded: 56",
        });
      }
      return <Table columns={columns} dataSource={data} pagination={false} />;
    };

    const columns = [
      { title: "Name", dataIndex: "name", key: "name" },
      { title: "Platform", dataIndex: "platform", key: "platform" },
      { title: "Version", dataIndex: "version", key: "version" },
      { title: "Upgraded", dataIndex: "upgradeNum", key: "upgradeNum" },
      { title: "Creator", dataIndex: "creator", key: "creator" },
      { title: "Date", dataIndex: "createdAt", key: "createdAt" },
      {
        title: "Action",
        key: "operation",
        render: () => (
          <button className="text-underline c-blue">Publish</button>
        ),
      },
    ];
    const data = [];
    for (let i = 0; i < 3; ++i) {
      data.push({
        key: i,
        name: "Screem",
        platform: "iOS",
        version: "10.3.4.5654",
        upgradeNum: 500,
        creator: "Jack",
        createdAt: "2014-12-24 23:12:00",
      });
    }
    return (
      <Table
        className="components-table-demo-nested"
        columns={columns}
        expandable={{ expandedRowRender }}
        dataSource={data}
      />
    );
  }
  onChangeMainCm = (e) => {
    var form = this.state.form;
    this.setState({ ckpm: false, ckcm: true });
    form["maintenance_type"] = "CM";
  };
  onChangeasset = (val, obj) => {
    this.setState({
      asset_name: obj.obj.asset_name === null ? "-" : obj.obj.asset_name,
      group_type: obj.obj.group_type_id === null ? "-" : obj.obj.group_type_id,
      asset_type:
        obj.obj.asset_type_name === null ? "-" : obj.obj.asset_type_name,
      ass_sub_type:
        obj.obj.asset_sub_type_name === null
          ? "-"
          : obj.obj.asset_sub_type_name,
      modal_number: obj.obj.model_no === null ? "-" : obj.obj.model_no,
      serial_number: obj.obj.serial_no === null ? "-" : obj.obj.serial_no,
      date_install: obj.obj.install_date === null ? "-" : obj.obj.install_date,
      warranty:
        obj.obj.warranty_expire === null ? "-" : obj.obj.warranty_expire,
      ass_lat: obj.obj.location_lat === null ? "-" : obj.obj.location_lat,
      ass_long: obj.obj.location_lon === null ? "-" : obj.obj.location_lon,
      ass_name: obj.obj.location_name === null ? "-" : obj.obj.location_name,
      ass_code: obj.obj.asset_code === null ? "-" : obj.obj.asset_code1,
      area_id: obj.obj.area_id === null ? "-" : obj.obj.area_id,
      asset_id: obj.obj.asset_id === null ? "-" : obj.obj.asset_id,
      sub_area_id: obj.obj.sub_area_id === null ? "-" : obj.obj.sub_area_id,
      // asset_ma: obj.obj.name,
    });
  };
  closeModal = () => {
    this.setState({
      modal_validate: false,
    });
  };
  handleSubmit = async () => {
    let val_asset = false;
    let val_obj_part = false;
    let val_service_type = false;
    let val_new_type = false;
    let val_sub_cat = false;
    var filed_list = [];
    if (
      (this.state.ckasset != false && this.state.asset_id != undefined) ||
      this.state.ckasset === true
    ) {
      val_asset = true;
    } else {
      filed_list.push("กรุณากรอก Asset ID ด้วยครับ !!!!");
    }
    if (this.state.customs.select_object_path) {
      val_obj_part = true;
    } else {
      filed_list.push("กรุณากรอก Select Object Path ด้วยครับ !!!!");
    }
    if (this.state.sel_type) {
      val_service_type = true;
    } else {
      filed_list.push("กรุณากรอก Service Type ด้วยครับ !!!!");
    }
    if (this.state.sel_new_type) {
      val_new_type = true;
    } else {
      filed_list.push("กรุณากรอก Category Type ด้วยครับ !!!!");
    }
    if (this.state.sel_sub_cat) {
      val_sub_cat = true;
    } else {
      filed_list.push("กรุณากรอก Sub Category ด้วยครับ !!!!");
    }

    if (
      val_obj_part === true &&
      val_service_type === true &&
      val_new_type === true &&
      val_sub_cat === true
    ) {
      if (this.state.asset_list.length === 0) {
        this.setState({ checkbtn: false });
        this.DataSubmit();
      } else {
        var PostData = [];
        this.setState({ checkbtn: false });
        for (let i = 0; i < this.state.asset_list.length; i++) {
          const DataSet = {
            inform_remark: this.state.form.remark,
            ma_period_id: this.state.form.ma_period_id,
            remark: this.state.form.remark,
            first_start_date: null,
            last_assign_date: moment(this.state.Assign_date).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            priority_level: this.state.Priority,
            job_no: 0,
            job_category_id: this.state.jobcategory,
            area_id: this.state.asset_list[i].area_id,
            multiple_asset_flag: 0,
            location_lat: this.state.asset_list[i].location_lat,
            location_lon: this.state.asset_list[i].location_lon,
            location_name: this.state.asset_list[i].location_name,
            asset_id: this.state.asset_list[i].asset_id,
            asset_code: this.state.asset_list[i].asset_code,
            sub_area_id: this.state.asset_list[i].sub_area_id,
            job_status: 0,
            create_by: Cookies.get("username"),
            operator_id: Cookies.get("operator_id"),
            project_id: Cookies.get("project_id"),
            job_type_id: this.state.selected_jobtype,
            job_sub_type_id: this.state.selected_subtype,
            inform_name: this.state.inform_name,
            inform_detail: this.state.form.inform_remark,
            ...this.state.WorkFlow[0],
            service_type_level_id: this.state.service_type_level_id,
            job_sla_id: this.state.sla_id,
            Plan_Start_Date: moment(this.state.plan_date[0]).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            Plan_end_date: moment(this.state.plan_date[1]).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
          };
          PostData.push(DataSet);
        }

        // ServiceApi.post("V2/insert_oper_job_multi_asset", PostData)
        ServiceApi.post("v4/insert_oper_job_multi_asset", PostData)

          .then(async (response) => {
            if (response.data.result.code === "P") {
              const { fileList } = this.state;
              const formData = new FormData();
              for (let i = 0; i < response.data.data.result_data.length; i++) {
                fileList.forEach((file) => {
                  formData.append("files", file["originFileObj"]);
                  formData.append(
                    "job_id",
                    response.data.data.result_data[i].job_id
                  );
                  formData.append("job_progress_id", 1);
                  formData.append("company_id", Cookies.get("companyid"));
                  formData.append("operator_id", Cookies.get("operator_id"));
                  formData.append("project_id", Cookies.get("project_id"));
                  formData.append("job_category_id", this.state.jobcategory);
                  formData.append("job_type_id", this.state.selected_jobtype);
                  formData.append(
                    "asset_id",
                    response.data.data.result_data[i].asset_id
                  );
                  formData.append("create_by", Cookies.get("username"));
                });
                if (fileList.length > 0) {
                  await axios({
                    method: "post",
                    url: this.state.urlpath + "InsertOperJobFile/",
                    data: formData,
                    headers: {
                      TokenUser: Cookies.get(`OperationToken`),
                    },
                    processData: false,
                  })
                    .then(function (response) {
                      for (
                        let i = 0;
                        i < formData.getAll("files").length;
                        i++
                      ) {
                        formData.delete("files");
                        formData.delete("job_id");
                        formData.delete("job_progress_id");
                        formData.delete("company_id");
                        formData.delete("operator_id");
                        formData.delete("project_id");
                        formData.delete("job_category_id");
                        formData.delete("job_type_id");
                        formData.delete("asset_id");
                        formData.delete("create_by");
                        message.success("upload successfully.");
                      }
                    })
                    .catch(function (response) {
                      //handle error
                      console.log(response);
                    });
                } else {
                  this.setState({
                    checkbtn: true,
                    modalstatus: true,
                  });
                }
                if (i === response.data.data.result_data.length - 1) {
                  this.setState({
                    fileList: [],
                    uploading: false,
                    modalstatus: true,
                  });
                }
              }
            }
          })
          .catch((e) => {
            this.setState({ checkbtn: true });
            alert(" API ERROR ");
            console.log(e);
          });
      }
    } else {
      this.setState({
        modal_validate: true,
        error_disPlay: filed_list,
      });
    }
    this.setState({
      valid_asset: val_asset,
      valid_obj_part: val_obj_part,
      valid_service_type: val_service_type,
      valid_new_type: val_new_type,
      valid_sub_cat: val_sub_cat,
      valid: true,
    });
  };
  DataSubmit = async () => {
    // const { dynamicReducer, setDynamic } = this.props;
    console.log(this.state.ass_lat);
    console.log(this.state.ass_long);
    console.log(this.state.form.ma_period_id);
    const DataSet = {
      inform_remark: this.state.form.remark,
      ma_period_id: this.state.form.ma_period_id,
      remark: this.state.form.remark,
      first_start_date: null,
      priority_level: this.state.Priority,
      job_no: 0,
      job_category_id: this.state.jobcategory,
      //area_id: this.state.area_id,
      //area_id: 0,
      multiple_asset_flag: 0,
      location_lat:
        this.state.ass_lat != "-" &&
        this.state.ass_lat != "" &&
        this.state.ass_lat &&
        " "
          ? this.state.ass_lat
          : 0,
      location_lon:
        this.state.ass_long != "-" &&
        this.state.ass_long != "" &&
        this.state.ass_long &&
        " "
          ? this.state.ass_long
          : 0,
      location_name: this.state.ass_name,
      asset_id: this.state.ckasset === true ? -1 : this.state.asset_id,
      asset_code: this.state.ckasset === true ? "" : this.state.ass_code,
      sub_area_id: this.state.sub_area_id,
      job_status: 0,
      create_by: Cookies.get("username"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_type_id: this.state.selected_jobtype,
      job_sub_type_id: this.state.selected_subtype,
      inform_name: this.state.inform_name,
      inform_detail: this.state.form.inform_remark,
      ...this.state.WorkFlow[0],
      service_type_level_id:
        this.state.service_type_level_id.length === 7
          ? "0" + this.state.service_type_level_id
          : this.state.service_type_level_id,
      job_sla_id: this.state.sla_id,
      Plan_Start_Date: moment(this.state.plan_date[0]).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      Plan_end_date: moment(this.state.plan_date[1]).format(
        "YYYY-MM-DD HH:mm:ss"
      ),

      // service_type_level_id: "01010101"
    };

    ServiceApi.post("v4/insert_oper_job_multi_asset", [DataSet])
      .then((response) => {
        if (response.data.result.code === "P") {
          const { fileList } = this.state;
          const formData = new FormData();
          fileList.forEach((file) => {
            formData.append("files", file["originFileObj"]);
            formData.append("job_id", response.data.data.result_data[0].job_id);
            formData.append("job_progress_id", 1);
            formData.append("company_id", Cookies.get("companyid"));
            formData.append("operator_id", Cookies.get("operator_id"));
            formData.append("project_id", Cookies.get("project_id"));
            formData.append("job_category_id", this.state.jobcategory);
            formData.append("job_type_id", this.state.selected_jobtype);
            //formData.append("asset_id", this.state.asset_id);
            formData.append("asset_id", 0);
            formData.append("create_by", Cookies.get("username"));
          });
          if (fileList.length > 0) {
            reqwest({
              url: this.state.urlpath + "InsertOperJobFile/",
              method: "post",
              processData: false,
              data: formData,
              headers: {
                TokenUser: Cookies.get(`OperationToken`),
              },
              success: () => {
                this.setState({
                  fileList: [],
                  uploading: false,
                  modalstatus: true,
                });
                message.success("upload successfully.");
              },
              error: () => {
                this.setState({
                  uploading: false,
                });
                message.error("upload failed.");
              },
            });
          } else {
            this.setState({
              modalstatus: true,
            });
          }
        } else {
          alert("API Eror");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  setConditions(data) {
    let option = data.split(",");
    let options = [];
    for (let i = 0; i < option.length; i++) {
      let _option = option[i].split("=");
      options.push({
        column_name: _option[0],
        value: _option[1],
      });
    }
    return options;
  }
  setFormsView(data) {
    const form_json = [];
    const form_json_parse = JSON.parse(data["form_json"]);
    for (let x in form_json_parse[data["table_name"]]) {
      form_json.push(form_json_parse[data["table_name"]][x]);
    }
    return form_json;
  }
  async Setdata_jobtype(value) {
    const checkwf = this.state.job_type.find(
      (element) => parseInt(element.job_type_id) === parseInt(value)
    );
    if (checkwf.wf_id === null) {
      this.setState({
        checkbtn: false,
      });
    } else {
      ServiceApi.post("getButtonDetailWeb", {
        WF_ID: checkwf.wf_id,
        CompanyID: Cookies.get("companyid"),
        ProjectID: Cookies.get("project_id"),
        JobTypeID: value,
        Version: 1,
        MainProcessID: "0",
        SubProcessID: "-1",
        ActionID: 1,
        UserName: Cookies.get("username"),
        operator_id: Cookies.get("operator_id"),
      })
        .then((response) => {
          if (
            response.data.return_nextWorkFlow.length === 0 ||
            response.data.return_nextWorkFlow === null
          ) {
            this.setState({
              checkbtn: false,
              status_button_workflow: "กรุณาตรวจสอบการเลือก Job Type !!",
            });
          } else {
            this.setState({
              checkbtn: true,
              WorkFlow: response.data.return_nextWorkFlow,
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
    ServiceApi.post("get_job_sub_type", {
      job_sub_type_id: null,
      job_category_id: this.state.jobcategory,
      job_type_id: value,
      is_active: 1,
      effective: 1,
      sql_where: " and company_id=" + Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      // sql_where: null,
    })
      .then((response) => {
        const result = response.data.data.job_sub_type_dto_list.filter(
          (data) => data.job_check_list_type != "PLN"
        );
        this.setState({
          selected_jobtype: value || null,
          selected_subtype: result[0].job_sub_type_id,
          sub_type: result,
        });
      })
      .catch((e) => {
        console.log(e);
      });
    ServiceApi.post("get_service_type_ma_list_each_level", {
      company_id: Cookies.get("companyid"),
      job_category_id: this.state.jobcategory,
      job_type_id: value,
      service_lv1: null,
      service_lv2: null,
      service_lv3: null,
      service_lv4: null,
      operator_id: Cookies.get("operator_id"),
    })
      .then((response) => {
        this.setState({
          ObjectPart: response.data.data.result,
        });
      })
      .catch((e) => {
        console.log(e);
      });
    this.setState({
      customs: {
        select_object_path: null,
      },
      sel_type: null,
      sel_new_type: null,
      sel_sub_cat: null,
      ObjectPart: [],
      serviceType: [],
      newType: [],
      subCategory: [],
      sla_level: [],
      std_hour: "",
      std_day: "",
      std_minute: "",
      sla_id: "",
      sel_sla: null,
      disabledAddAsset: true,
    });
  }
  onMoreDetail() {
    const { dynamicReducer, setDynamic } = this.props;
    setDynamic(dynamicReducer.dynamic, true);
    const dataMasFormJson = this.state.data_dynamic_from[0];
    if (
      dataMasFormJson["expire_date"] !== "" &&
      dataMasFormJson["expire_date"] !== null
    ) {
      dataMasFormJson["expire_date"] = moment(
        dataMasFormJson["expire_date"],
        "YYYY/MM/DD"
      );
    }
    dataMasFormJson["condition"] = this.setConditions(
      dataMasFormJson["data_roles"]
    );
    dataMasFormJson["forms"] = this.setFormsView(dataMasFormJson);
    dataMasFormJson["language_name"] = Array.isArray(
      dataMasFormJson["language_name"]
    )
      ? dataMasFormJson["language_name"]
      : dataMasFormJson["language_name"].split(",");
    dataMasFormJson["language"] = Array.isArray(dataMasFormJson["language"])
      ? dataMasFormJson["language"]
      : dataMasFormJson["language"].split(",");
    this.setState(
      {
        dataMasFormJson_Call: dataMasFormJson,
      },
      () => {
        //this.setState({ visible_detail: false });
        //if()
        setDynamic(dynamicReducer.dynamic, true);
      }
    );
  }
  /* function check condition dynamic form */
  checkConditionBeforeRender = () => {
    let companyid = this.state.company_id;
    let DataShema = "maxi_operation";
    let allDataDynamic = this.state.data_dynamic_from;
    // let conditionType = {};

    let companyDataDynamic = allDataDynamic.filter((data) => {
      return data.company_id == companyid && data.schema == DataShema;
    });

    return companyDataDynamic;
  };
  handleproblem = async (name, value, status, jobtype_name, data) => {
    switch (name) {
      case "objectpart":
        this.setState({
          customs: {
            select_object_path: value,
          },
        });
        ServiceApi.post("get_service_type_ma_list_each_level", {
          company_id: Cookies.get("companyid"),
          job_category_id: this.state.jobcategory,
          job_type_id: this.state.selected_jobtype,
          service_lv1: value.substring(0, 2),
          service_lv2: null,
          service_lv3: null,
          service_lv4: null,
          operator_id: Cookies.get("operator_id"),
        })
          .then((response) => {
            console.log(response);
            this.setState({
              service_type_level_id: value.substring(0, 2),
              serviceType: response.data.data.result,
              sel_type:
                response.data.data.result.length === 1
                  ? response.data.data.result[0].service_type_level_id
                  : null,
              sel_new_type: null,
              sel_sub_cat: null,
              newType: [],
              subCategory: [],
              std_hour: "",
              std_day: "",
              std_minute: "",
              sla_id: "",
              sel_sla: null,
            });
            if (response.data.data.result.length === 1) {
              this.handleproblem(
                "servicetype",
                response.data.data.result[0].service_type_level_id
              );
            }
            if (status === "Add Asset") {
              const filter_service_type = this.state.serviceType.filter(
                (data) => data.service_desc === jobtype_name
              );
              if (filter_service_type.length === 0) {
                this.setState({
                  asset_list: data,
                  visible_addasset: false,
                  checkAssetType: true,
                });
              } else {
                this.setState({
                  sel_type: filter_service_type[0].service_type_level_id,
                  asset_list: data,
                  visible_addasset: false,
                  checkAssetType: true,
                });
                if (
                  this.state.jobcategory === 1 ||
                  this.state.jobcategory === "1"
                ) {
                  ServiceApi.post("get_job_sla_special", {
                    company_id: Cookies.get("companyid"),
                    operator_id: Cookies.get("operator_id"),
                    project_id: Cookies.get("project_id"),
                    job_category_id: this.state.jobcategory,
                    job_type_id: this.state.selected_jobtype,
                    job_sub_type_id: 0,
                    service_type_level_id: null,
                    v_where:
                      " and service_type_level_id like concat('" +
                      filter_service_type[0].service_type_level_id.substring(
                        0,
                        4
                      ) +
                      "','%')",
                  })
                    .then((result_sub_category) => {
                      this.setState({
                        service_type_level_id: data[0].service_type_level_id,
                        subCategory: result_sub_category.data.data.result,
                        asset_list: data,
                        visible_addasset: false,
                        checkAssetType: false,
                      });
                    })
                    .catch((e) => {
                      console.log(e);
                    });
                }
              }
            }
          })
          .catch((e) => {
            console.log(e);
          });
        break;
      case "servicetype":
        ServiceApi.post("get_service_type_ma_list_each_level", {
          company_id: Cookies.get("companyid"),
          job_category_id: this.state.jobcategory,
          job_type_id: this.state.selected_jobtype,
          service_lv1: value.substring(0, 2),
          service_lv2: value.substring(2, 4),
          service_lv3: null,
          service_lv4: null,
          operator_id: Cookies.get("operator_id"),
        })
          .then((response) => {
            console.log(response);
            this.setState({
              service_type_level_id:
                this.state.service_type_level_id + value.substring(2, 4),
              sel_type: value,
              newType: response.data.data.result,
              sel_new_type:
                response.data.data.result.length === 1
                  ? response.data.data.result[0].service_type_level_id
                  : null,
              subCategory: [],
              // sla_level: [],
              std_hour: "",
              std_day: "",
              std_minute: "",
              sla_id: "",
              sel_sla: null,
            });
            if (response.data.data.result.length === 1) {
              this.handleproblem(
                "new_type",
                response.data.data.result[0].service_type_level_id
              );
            }
          })
          .catch((e) => {
            console.log(e);
          });
        break;
      case "new_type":
        ServiceApi.post("get_service_type_ma_list_each_level", {
          company_id: Cookies.get("companyid"),
          job_category_id: this.state.jobcategory,
          job_type_id: this.state.selected_jobtype,
          service_lv1: value.substring(0, 2),
          service_lv2: value.substring(2, 4),
          service_lv3: value.substring(4, 6),
          service_lv4: null,
          operator_id: Cookies.get("operator_id"),
        })
          .then((response) => {
            console.log(response);
            this.setState({
              sel_new_type: value,
              service_type_level_id: value,
              subCategory: response.data.data.result,
              sel_sub_cat:
                response.data.data.result.length === 1
                  ? response.data.data.result[0].service_type_level_id
                  : null,
              std_hour: "",
              std_day: "",
              std_minute: "",
              sla_id: "",
              sel_sla: null,
            });
            if (response.data.data.result.length === 1) {
              this.handleproblem(
                "sub_category",
                response.data.data.result[0].service_type_level_id
              );
            }
          })
          .catch((e) => {
            console.log(e);
          });
        break;
      case "sub_category":
        if (this.state.checkAssetType === true) {
          const get_job_sla = await ServiceApi.post("get_job_sla", {
            company_id: Cookies.get("companyid"),
            operator_id: Cookies.get("operator_id"),
            project_id: Cookies.get("project_id"),
            job_category_id: this.state.jobcategory,
            job_type_id: this.state.selected_jobtype,
            job_sub_type_id: 0,
            service_type_level_id: value,
          });
          console.log(get_job_sla);
          this.setState({
            service_type_level_id: value,
            sla_level: get_job_sla.data.data.result,
            sel_sub_cat: value,
            sel_sla: get_job_sla.data.data.result[0].job_sla_id,
            std_hour: get_job_sla.data.data.result[0].sla_time_hour,
            std_day: get_job_sla.data.data.result[0].sla_time_day,
            std_minute: get_job_sla.data.data.result[0].sla_time_min,
            sla_id: get_job_sla.data.data.result[0].job_sla_id,
          });
        } else {
          const filter_subcat = this.state.subCategory.filter(
            (data) => data.service_type_level_id === value
          );
          this.setState({
            service_type_level_id: value,
            sel_new_type: value,
            newType: filter_subcat,
            sel_sub_cat: value,
            sla_level: filter_subcat,
            sel_sla: filter_subcat[0].job_sla_id,
            std_hour: filter_subcat[0].sla_time_hour,
            std_day: filter_subcat[0].sla_time_day,
            std_minute: filter_subcat[0].sla_time_min,
            sla_id: value,
          });
        }
        break;
      case "sla":
        this.setState({
          std_hour: "",
          std_day: "",
          std_minute: "",
          sla_id: "",
        });
        this.setState({
          sel_sla: value,
          std_hour: this.state.sla_level[0].sla_time_hour,
          std_day: this.state.sla_level[0].sla_time_day,
          std_minute: this.state.sla_level[0].sla_time_day,
          sla_id: value,
          service_type_level_id: this.state.sla_level[0].service_type_level_id,
        });
        break;
      default:
        return null;
    }
  };
  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
  handleChange = ({ fileList }) => this.setState({ fileList });
  handleCancel = () => this.setState({ previewVisible: false });
  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    });
  };
  onFilter = async (value) => {
    await this.setState({
      data_asset: [],
    });
    if (value != undefined) {
      const filteredWarehouse = this.state.set_asset.filter((o) =>
        Object.keys(o).some((k) =>
          String(o[k]).toLowerCase().includes(value.toLowerCase())
        )
      );
      this.setState({
        data_asset: filteredWarehouse,
      });
    } else {
      this.setState({
        data_asset: this.state.set_asset,
      });
    }
  };
  handlePackage = async (index) => {
    await this.setState({
      data_asset: [],
    });
    if (index === 1) {
      this.setState({
        data_asset: [],
        master_asset_package: [],
        modal_type_asset: index,
      });
    } else {
      this.setState({
        data_asset: this.state.master_asset,
        modal_type_asset: index,
      });
    }
  };
  renderModalAssign() {
    const { visible_addasset, asset_loading } = this.state;
    return (
      <Modal
        title={<b style={{ color: "#000F9F", fontSize: "20px" }}>Add Assets</b>}
        centered
        visible={visible_addasset}
        footer={null}
        closable={false}
        className="custom-modal-map-large"
      >
        <div className="row" style={{ marginLeft: "0px", marginRight: "0px" }}>
          <div className="col-3 mt-3">
            <Radio.Group
              onChange={(value) => this.handlePackage(value.target.value)}
              value={this.state.modal_type_asset}
            >
              <Radio value={0}>
                <b style={{ color: "#0500A3" }}>Assets</b>
              </Radio>
              <Radio value={1}>
                <b style={{ color: "#0500A3" }}>Package</b>
              </Radio>
            </Radio.Group>
          </div>
          <div className="col-4 mt-3">
            {/* Comment With Data */}
            {this.state.modal_type_asset === 0 ? (
              <Search
                placeholder=" Search Asset "
                // style={{ width: 350 }}
                onChange={(e) => this.onFilter(e.target.value)}
              />
            ) : (
              <AutoComplete
                style={{
                  width: "100%",
                }}
                onChange={(value) => this.handlePackageSearch(value, "Package")}
                options={this.state.data_package}
                onSelect={(value) => this.handlePackageData(value)}
                allowClear
                placeholder=" input search Package "
                filterOption={(inputValue, option) =>
                  option.value
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
              />
            )}
          </div>
          <div className="col-4 mt-3 ">
            <Select
              showSearch
              style={{ border: "0px", width: "80%" }}
              placeholder="Select a Type Asset"
              // className="inputfile"
              onChange={(e) => this.ChangeAssetType(e)}
              allowClear
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children === "" || option.children === null
                  ? null
                  : option.children
                      .toLowerCase()
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
              }
              // value={this.state.ass_code}
            >
              {this.state.asset_select.map((item, index) => (
                <Select.Option value={item.asset_type_name} key={index}>
                  {item.asset_type_name}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div className="col-12">
            <div className="p-4">
              <div style={{ overflow: "auto" }}>
                <Table
                  size="middle"
                  rowKey={
                    this.state.modal_type_asset === 0 ? "asset_id" : "part_id"
                  }
                  loading={asset_loading}
                  columns={this.state.columns_asset}
                  dataSource={this.state.data_asset}
                />
              </div>
              <div className="mt-4 text-center">
                <button
                  type="reset"
                  onClick={() => this.setState({ visible_addasset: false })}
                  className="btn btn-secondary"
                >
                  Close
                </button>
                <button
                  className="btn btn-success"
                  onClick={() => this.confirm()}
                >
                  {"Confirm"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
  confirm = async () => {
    const result = (
      this.state.modal_type_asset === 0
        ? this.state.set_asset
        : this.state.data_asset
    ).filter((data) => data.status_checkbox === true);
    if (result.length === 1 && this.state.ObjectPart.length > 0) {
      const filter_objectPath = this.state.ObjectPart.filter(
        (data) => data.service_desc === result[0].asset_type_name
      );
      const filter_jobtype = this.state.job_type.filter(
        (data_jobtype) =>
          parseInt(data_jobtype.job_type_id) ===
          parseInt(this.state.selected_jobtype)
      );
      if (filter_objectPath.length === 0) {
        this.setState({
          customs: {
            select_object_path: this.state.ObjectPart[0].service_type_level_id,
          },
          asset_list: result,
          visible_addasset: false,
          serviceType: [],
          sel_type: "",
          sel_sub_cat: "",
          subCategory: [],
          sel_sla: "",
          sla_level: [],
          std_day: "",
          std_hour: "",
          minute: "",
          newType: [],
          sel_new_type: "",
          customs: {
            select_object_path: "",
          },
          checkAssetType: true,
        });
        // this.handleproblem("objectpart", this.state.ObjectPart[0].service_type_level_id)
      } else {
        this.handleproblem(
          "objectpart",
          filter_objectPath[0].service_type_level_id,
          "Add Asset",
          filter_jobtype[0].job_type_name,
          result
        );
        this.setState({
          customs: {
            select_object_path: filter_objectPath[0].service_type_level_id,
          },
        });
      }
    } else {
      if (this.state.ObjectPart.length === 0) {
        this.handleSLA();
        this.setState({
          asset_list: result,
          visible_addasset: false,
          checkAssetType: true,
        });
      } else {
        this.setState({
          asset_list: result,
          visible_addasset: false,
          checkAssetType: true,
        });
      }
    }

  var setValueJob = "" ; 
  result.forEach(element => setValueJob += element.asset_id + ",");
  this.loadDataJobHistory(setValueJob.substring(0 , setValueJob.length - 1));


  };
  handleSLA = () => {
    this.setState({
      customs: { select_object_path: "-" },
      sel_type: "-",
      sel_new_type: "-",
      sel_sub_cat: "-",
      service_type_level_id: "",
      sla_id: "",
      std_hour: 0,
      std_day: 0,
      std_minute: 0,
      sel_sla: "-",
    });
  };
  handlePackageSearch = async (value, name) => {
    var dataset = [];
    dataset = [];
    const Search_Package = await ServiceApi.post("Search_Package", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      part_num: null,
      part_desc: null,
      media_group_id: null,
      media_group_name: null,
      v_where: " and  concat(part_num, part_desc) like ('%" + value + "%')",
    });
    Search_Package.data.data.result.forEach((element) =>
      dataset.push({
        value: element.part_num + " " + element.part_desc,
      })
    );
    this.setState({
      data_package: dataset,
    });
  };
  handlePackageData = async (value) => {
    var res = value.split(" ");
    await this.setState({
      data_asset: [],
      asset_loading: true,
    });
    if (value != undefined) {
      const Search_Asset_in_Package = await ServiceApi.post(
        "Search_Asset_in_Package",
        {
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          part_num: null,
          part_desc: null,
          media_group_id: null,
          media_group_name: null,
          v_where:
            " and  concat(part_num, part_desc) like ('%" + res[0] + "%')",
        }
      );
      console.log(Search_Asset_in_Package.data.data.result);
      for (
        let i = 0;
        i < Search_Asset_in_Package.data.data.result.length;
        i++
      ) {
        Search_Asset_in_Package.data.data.result[i]["status_checkbox"] = false;
        Search_Asset_in_Package.data.data.result[i]["id"] = i;
      }
      this.setState({
        data_asset: Search_Asset_in_Package.data.data.result,
        master_asset_package: Search_Asset_in_Package.data.data.result,
        asset_loading: false,
      });
    } else {
      this.setState({
        data_asset: [],
        master_asset_package: [],
        asset_loading: false,
      });
    }
  };
  loadDataJobHistory = (value) => {
    ServiceApi.post("checklistjobasset", {
      "company_id": Cookies.get("companyid"),
      "operator_id": Cookies.get("operator_id"),
      "project_id": Cookies.get("project_id"),
      "asset_id": value,
      "job_category_id": this.state.jobcategory
    })
      .then((response) => {
        this.setState({
          job_history : response.data.data.result_oper_job
        })
      })
      .catch((e) => {
        console.log(e);
      });
  }
  render() {
    const { title, uploading, fileList, form } = this.state;
    const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];
    const uploadButton = (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );
    const job_cat_btn = this.state.job_cat.map((job_cat, index) => {
      let thismr = "";
      if ((index + 1) % 5 == 0 && index != 0) {
        thismr = "mr-2 ";
      }
      return (
        <div
          key={index + 54547}
          className={"col-2 " + thismr + "p0"}
          style={{ marginBottom: "10px" }}
        >
          <button
            type="button"
            className={
              this.state.jobcategory == job_cat.job_category_id
                ? "btndetailshow"
                : "btndetailhide"
            }
            onClick={this.btnjobDetail.bind(this, job_cat.job_category_id)}
          >
            <img
              style={{
                float: "right",
                marginRight: "10px",
              }}
              src={
                this.state.jobcategory == job_cat.job_category_id
                  ? ServiceApi.absoluteUrl("/icon/job_show.svg")
                  : ServiceApi.absoluteUrl("/icon/job_dis.svg")
              }
            />
            <br className="mt-2" />
            <img
              style={{
                float: "center",
                marginLeft: "-15px",
              }}
              src={ServiceApi.absoluteUrl("/icon/" + job_cat.icon_name)}
            />
            <span
              style={{
                marginLeft: "-20px",
                fontSize: "14px",
                color: "#0500A3",
              }}
            >
              <br className="mt-2" />
              {job_cat.job_category_name}
            </span>
          </button>
        </div>
      );
    });
    return (
      <LayoutOperation title={title}>
        {this.state.modalstatus ? (
          <ModalSuccess
            status="Successfully"
            path_location={ServiceApi.absoluteUrl("/ma_list")}
          />
        ) : null}
        {this.renderModalAssign()}
        {/*  ============================== Header Page  ==============================*/}
        <div className="row mb-2">
          <div className="col-sm-6 mt-3 ">
            <a
              href="/"
              className="ml-5  text-dark"
              style={{ color: "#2B2D33", fontSize: "18px", textAlign: "left" }}
            >
              {"< "} Back
            </a>
          </div>
          <div className="col-sm-6">
            <ol
              className="breadcrumb float-sm-right mr-5  mt-3"
              style={{ background: "inherit" }}
            >
              <li className="breadcrumb-item">MA List</li>
              <li className="breadcrumb-item">
                <a href="/"> ADD JOB MAINTENANCE</a>
              </li>
            </ol>
          </div>
        </div>
        {/*  ==============================  Page  Body ==============================*/}
        <div
          className="container mb-2"
          style={{ maxWidth: "95%", marginTop: "0%" }}
        >
          <div className="row">
            <div
              className="col-12"
              style={{ paddingLeft: "0px", paddingRight: "0px" }}
            >
              <a
                href="/MaxiOperation/ma_list"
                // className="btn btn-gray"
                style={{
                  float: "left",
                  color: "#000f9f",
                  textDecoration: "underline",
                }}
              >
                {"< "} Back
              </a>
            </div>
            <div
              className="col-12 mt-2 "
              style={{ paddingLeft: "0px", paddingRight: "0px" }}
            >
              <span style={{ color: "#0500A3", fontSize: "16px" }}>
                <img
                  src={ServiceApi.absoluteUrl("/icon/pust.svg")}
                  width="14"
                  className="mr-2"
                />
                <b> ADD JOB MAINTENANCE </b>
              </span>
              <div style={{ textAlign: "center" }} className="mt-5 mb-5">
                <button
                  type="button"
                  className={
                    this.state.statusbtn == "1"
                      ? "btnImport p-1 divhide"
                      : "btndisabled p-1 divhide"
                  }
                  onClick={() =>
                    this.setState({ statusbtn: "1", fileList: [] })
                  }
                >
                  <img
                    style={{
                      float: "left",
                      marginTop: "3px",
                      marginLeft: "10px",
                    }}
                    src={
                      this.state.statusbtn == "1"
                        ? ServiceApi.absoluteUrl("/img/importdis.svg")
                        : ServiceApi.absoluteUrl("/img/import.svg")
                    }
                  />
                  <span style={{ marginLeft: "-20px", fontSize: "18px" }}>
                    Import file
                  </span>
                  <img
                    style={{ float: "right", marginTop: "-10px" }}
                    src={
                      this.state.statusbtn == "1"
                        ? ServiceApi.absoluteUrl("/icon/btncircle.svg")
                        : ServiceApi.absoluteUrl("/icon/btncircledis.svg")
                    }
                  />
                </button>
                <button
                  type="button"
                  className={
                    this.state.statusbtn != "2"
                      ? "btndisabled ml-3 p-1"
                      : "btnImport ml-3 p-1"
                  }
                  onClick={() => this.setState({ statusbtn: "2" })}
                >
                  <img
                    style={{
                      float: "left",
                      marginTop: "3px",
                      marginLeft: "10px",
                    }}
                    src={
                      this.state.statusbtn != "2"
                        ? ServiceApi.absoluteUrl("/img/Manul.svg")
                        : ServiceApi.absoluteUrl("/img/Manuldis.svg")
                    }
                  />
                  <span style={{ marginLeft: "-20px", fontSize: "18px" }}>
                    Manual
                  </span>
                  <img
                    style={{ float: "right", marginTop: "-10px" }}
                    src={
                      this.state.statusbtn != "2"
                        ? ServiceApi.absoluteUrl("/icon/btncircledis.svg")
                        : ServiceApi.absoluteUrl("/icon/btncircle.svg")
                    }
                  />
                </button>
                <button
                  type="button"
                  className={
                    this.state.statusbtn == "3"
                      ? "btnImport ml-3 p-1 divhide"
                      : "btndisabled ml-3 p-1 divhide"
                  }
                  onClick={() => this.setState({ statusbtn: "3" })}
                >
                  <img
                    style={{
                      float: "left",
                      marginTop: "3px",
                      marginLeft: "10px",
                    }}
                    src={
                      this.state.statusbtn == "3"
                        ? ServiceApi.absoluteUrl("/img/from_planb.svg")
                        : ServiceApi.absoluteUrl("/img/from_planbdis.svg")
                    }
                  />
                  <span style={{ marginLeft: "-20px", fontSize: "18px" }}>
                    From Plan
                  </span>
                  <img
                    style={{ float: "right", marginTop: "-10px" }}
                    src={
                      this.state.statusbtn == "3"
                        ? ServiceApi.absoluteUrl("/icon/btncircle.svg")
                        : ServiceApi.absoluteUrl("/icon/btncircledis.svg")
                    }
                  />
                </button>
              </div>
              <div className="card mt-2" style={{ width: "95%" }}>
                <div className="card-body">
                  {/* ========================================  Import File ===================================== */}
                  <div
                    style={{ textAlign: "center" }}
                    className={
                      this.state.statusbtn == "1" ? "divshow" : "divhide"
                    }
                  >
                    <div>
                      <Upload
                        action={this.state.urlpath + "mockupupload/"}
                        listType="picture-card"
                        // fileList={fileList}
                        onPreview={this.handlePreview}
                        onChange={(file) => console.log(file)}
                        onClick={() => alert("Custim")}
                      >
                        {fileList.length >= 8 ? null : uploadButton}
                      </Upload>
                      <Modal
                        visible={this.state.previewVisible}
                        title={this.state.previewTitle}
                        footer={null}
                        onCancel={this.handleCancel}
                      >
                        <img
                          alt="example"
                          style={{ width: "100%" }}
                          src={this.state.previewImage}
                        />
                      </Modal>
                    </div>
                    <br />
                  </div>
                  <div
                    style={{ textAlign: "center", fontSize: "18px" }}
                    className={
                      this.state.statusbtn == "1"
                        ? "mt-4 divshow"
                        : "mt-4 divhide"
                    }
                  >
                    <br />
                    {/* <div>
                      <label style={{ fontSize: " 18px", marginLeft: "-19%" }}>
                        Job Type <b style={{ color: "#DF4547" }}>*</b>
                      </label>
                      <br />
                    </div> */}
                    <div style={{ textAlign: "center" }} className="mt-5 mb-5">
                      <Button
                        type="primary"
                        // onClick={this.handleUpload}
                        disabled={fileList.length === 0}
                        loading={uploading}
                        className="btnbrows"
                      >
                        {uploading ? "Uploading" : "Submit"}
                      </Button>
                    </div>
                  </div>
                  {/* =====================================  Import Manual ===================================== */}
                  <div
                    className={
                      this.state.statusbtn == "2"
                        ? "mt-2 divshow"
                        : "mt-2  divhide"
                    }
                  >
                    <div className="row">
                      <div className="col-2"> </div>
                      <div className="col-10">
                        <img
                          style={{
                            float: "left",
                            marginTop: "16px",
                            marginRight: "10px",
                          }}
                          src={ServiceApi.absoluteUrl("/icon/setting.svg")}
                        />
                        {this.state.factupdate ? (
                          <span
                            className="jobdetail font-thai-b"
                            style={{ fontSize: "28px" }}
                          >
                            {
                              this.state.data_translate[Cookies.get("locale")][
                                "job_detail"
                              ]
                            }
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3"> </div>
                      <div className="col-9">
                        <div className="row">
                          <div className="col-12">
                            {this.state.factupdate ? (
                              <label
                                className="labeaddjob font-thai-r"
                                style={{ fontSize: "16px" }}
                              >
                                {
                                  this.state.data_translate[
                                    Cookies.get("locale")
                                  ]["job_category"]
                                }
                                <b style={{ color: "#DF4547" }}>*</b>
                              </label>
                            ) : null}
                            <br /> <div className="row">{job_cat_btn}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-5">
                      <div className="col-3"> </div>
                      <div className="col-9">
                        <div className="row">
                          <div className="col-5">
                            {this.state.factupdate ? (
                              <label
                                className="labeaddjob font-thai-r"
                                style={{ fontSize: "16px" }}
                              >
                                {
                                  this.state.data_translate[
                                    Cookies.get("locale")
                                  ]["job_type"]
                                }
                                <b style={{ color: "#DF4547" }}> * </b>
                              </label>
                            ) : null}
                            <br />
                            <Select
                              style={{ width: "94%" }}
                              value={this.state.selected_jobtype || ""}
                              className="dropdrowtype"
                              onChange={(value) => this.Setdata_jobtype(value)}
                            >
                              <Select.Option value="" disabled>
                                Please select
                              </Select.Option>
                              {this.state.job_type.map((item, index) => (
                                <Select.Option
                                  key={index}
                                  value={item.job_type_id}
                                >
                                  {item.job_type_name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                          <div className="col-6 ml-4">
                            {this.state.factupdate ? (
                              <label
                                className="labeaddjob font-thai-r"
                                style={{ fontSize: "16px" }}
                              >
                                {
                                  this.state.data_translate[
                                    Cookies.get("locale")
                                  ]["job_sub_type"]
                                }
                              </label>
                            ) : null}
                            <br />
                            <Select
                              style={{ width: "94%" }}
                              value={this.state.selected_subtype || ""}
                              className="dropdrowtype"
                              onChange={(value) =>
                                this.setState({
                                  selected_subtype: value,
                                })
                              }
                            >
                              <Select.Option value="" disabled>
                                Please select
                              </Select.Option>
                              {this.state.sub_type.map((item, index) => (
                                <Select.Option
                                  key={index}
                                  value={item.job_sub_type_id}
                                >
                                  {item.job_type_name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* ========================================  From Plan  ========================================*/}
                  <div
                    style={{ textAlign: "center" }}
                    className={
                      this.state.statusbtn == "3" ? "divshow" : "divhide"
                    }
                  >
                    <div className="row">
                      <div className="col-4">
                        <DatePicker
                          // selected={this.state.startDate}
                          defaultValue={moment(
                            this.state.startDate,
                            dateFormatList[0]
                          )}
                          format={dateFormatList}
                          onChange={(date) =>
                            this.setState({ startDate: date })
                          }
                          inline
                        />
                        <hr />
                        <h4 style={{ textAlign: "left" }}>
                          <img
                            src={ServiceApi.absoluteUrl("/img/from_planb.svg")}
                            style={{
                              float: "left",
                              marginTop: "3px",
                              marginLeft: "10px",
                              marginRight: "10px",
                            }}
                          />
                          Planning
                        </h4>

                        {this.state.team_list.map((item, index) => (
                          <div
                            key={index}
                            className={
                              this.state.active === index
                                ? "card-planning-list active"
                                : "card-planning-list"
                            }
                          >
                            <a
                              className="d-flex justify-content-between align-items-center"
                              onClick={() => this.setState({ active: index })}
                            >
                              <span className="name font-thai-b font18">
                                Team {item.name}
                              </span>
                              <span className="font-thai-r font16">
                                Asset : {item.asset}
                              </span>
                            </a>
                          </div>
                        ))}
                      </div>
                      <div className="col-8">
                        <div className="row">
                          <div className="col" style={{ textAlign: "left" }}>
                            <span style={{ color: "#000F9F" }}>
                              {moment(new Date()).format("dddd")}
                            </span>
                            <h5 style={{ color: "#000F9F" }}>
                              {moment(new Date()).format("D MMMM YYYY")}
                            </h5>
                          </div>

                          <div className="col" style={{ textAlign: "right" }}>
                            <h5
                              style={{ color: "#000F9F", marginBottom: "0px" }}
                            >
                              50
                            </h5>
                            <span style={{ color: "#000F9F" }}>Jobs</span>
                          </div>
                        </div>
                        <hr style={{ border: "1px solid #E8CE00" }} />
                        <div className="row">
                          <div className="col-12">
                            <this.NestedTable />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*  ====================  Asset Details ============================== */}
            <div
              className={
                this.state.statusbtn == "2"
                  ? "card mt-2 divshow"
                  : "card mt-2 divhide"
              }
              style={{ width: "95%" }}
            >
              <div className="card-body">
                <div
                  className={
                    this.state.statusbtn == "2"
                      ? "mt-2 divshow"
                      : "mt-2  divhide"
                  }
                >
                  <div className="row mt-3">
                    <div className="col-2"> </div>

                    <div className="col-10">
                      <img
                        style={{
                          float: "left",
                          marginTop: "7px",
                          marginRight: "10px",
                        }}
                        src={ServiceApi.absoluteUrl("/icon/Asset.svg")}
                      />

                      {this.state.factupdate ? (
                        <span className="jobdetail font-thai-b">
                          {
                            this.state.data_translate[Cookies.get("locale")][
                              "asset_detail"
                            ]
                          }
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-3"> </div>
                    <div className="col-9">
                      <div className="row">
                        <div className="col-4" style={{ margin: "auto" }}>
                          <Checkbox
                            onChange={this.checkAsset}
                            checked={this.state.ckasset}
                            style={{ fontSize: "20px", color: "#0500A3" }}
                          >
                            {this.state.factupdate ? (
                              <label
                                className="labelheader font-thai-r"
                                style={{ fontSize: "18px" }}
                              >
                                {
                                  this.state.data_translate[
                                    Cookies.get("locale")
                                  ]["no_asset"]
                                }
                              </label>
                            ) : null}
                          </Checkbox>
                          <br />
                          <div
                            className={
                              this.state.ckasset == true ? "divhide" : "divshow"
                            }
                          >
                            <br />
                            {this.state.status_cookie === 1 ? (
                              <input
                                type="text"
                                className="inputfile"
                                style={{ width: "100%" }}
                                name="location_name"
                                disabled={
                                  this.state.ckasset === true ? "" : "disabled"
                                }
                                value={this.state.asset_id}
                              ></input>
                            ) : null}
                          </div>
                        </div>
                        <div
                          className="col-6 divshow"
                          // style={{ margin: "auto" }}
                        ></div>
                      </div>
                    </div>
                    <div
                      className="col-12 mt-3"
                      style={{ textAlign: "center", overflow: "auto" }}
                    >
                      <Table
                        size="middle"
                        rowKey=""
                        columns={this.state.columns_asset_list}
                        dataSource={this.state.asset_list}
                      />
                    </div>
                    <div
                      className="col-12 mt-2"
                      style={{ textAlign: "center" }}
                    >
                      <Button
                        className="mt-2"
                        style={
                          this.state.disabledAddAsset === false
                            ? {
                                color: "rgb(200 200 200)",
                                width: "181px",
                                height: "36px",
                                border: "1px solid rgb(200 200 200)",
                                opacity: 1,
                              }
                            : {
                                color: "#000F9F",
                                width: "181px",
                                height: "36px",
                                border: "1px solid #000F9F",
                                opacity: 1,
                              }
                        }
                        disabled={!this.state.disabledAddAsset}
                        onClick={() =>
                          this.setState({ visible_addasset: true })
                        }
                      >
                        <b className="ml-2">Add Asset</b>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*  ============================================================================= */}
            {/*  ====================  Job History ============================== */}
            <div
              className={
                this.state.statusbtn == "2"
                  ? "card mt-2 divshow"
                  : "card mt-2 divhide"
              }
              style={{ width: "95%" }}
            >
              <div className="card-body">
                <div
                  className={
                    this.state.statusbtn == "2"
                      ? "mt-2 divshow"
                      : "mt-2  divhide"
                  }
                >
                  <div className="row mt-3">
                    <div className="col-2"> </div>

                    <div className="col-10">
                      <img
                        style={{
                          float: "left",
                          marginTop: "7px",
                          marginRight: "10px",
                          width: "20px"
                        }}
                        src={ServiceApi.absoluteUrl("/icon/database.svg")}
                      />
                      <span className="jobdetail font-thai-b">
                        {"Job History"}
                      </span>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12">
                      <Table
                        size="middle"
                        rowKey=""
                        columns={this.state.columns_job_history}
                        dataSource={this.state.job_history}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*  ============================================================================= */}
            <div
              className={
                this.state.statusbtn == "2"
                  ? "card mt-2 divshow"
                  : "card mt-2 divhide"
              }
              style={{ width: "95%" }}
            >
              <div className="card-body">
                <div
                  className={
                    this.state.statusbtn == "2"
                      ? "mt-2 divshow"
                      : "mt-2  divhide"
                  }
                >
                  <div className="row mt-3">
                    <div className="col-2"> </div>

                    <div className="col-10">
                      <img
                        style={{
                          float: "left",
                          marginTop: "15px",
                          marginRight: "10px",
                        }}
                        src={ServiceApi.absoluteUrl("/icon/alert.svg")}
                      />
                      {this.state.factupdate ? (
                        <span
                          className="jobdetail font-thai-b"
                          style={{ fontSize: "28px" }}
                        >
                          {
                            this.state.data_translate[Cookies.get("locale")][
                              "problem_detail"
                            ]
                          }
                        </span>
                      ) : null}
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-3"> </div>
                    <div className="col-7">
                      <div className="row">
                        <div className="col-6">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["inform_date"]
                              }
                            </label>
                          ) : null}
                          <br />
                          <DatePicker
                            className="datepicker"
                            defaultValue={moment(
                              this.state.DateTime_Install,
                              dateFormatList[0]
                            )}
                            format={dateFormatList}
                            onChange={(value) =>
                              this.handleDateChange("date_install", value)
                            }
                            style={{ width: "90%" }}
                          />
                        </div>
                        <div className="col-6">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["inform_name"]
                              }
                            </label>
                          ) : null}
                          <br />
                          <input
                            type="text"
                            className="inputfile"
                            style={{ width: "100%", padding: "5px" }}
                            onChange={(e) =>
                              this.setState({ inform_name: e.target.value })
                            }
                            name="inform_name"
                            value={this.state.inform_name}
                          ></input>
                        </div>
                        <div className="col-6 mt-2 divhide">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["assign_date"]
                              }
                            </label>
                          ) : null}
                          <br />
                          <DatePicker
                            className="datepicker"
                            defaultValue={moment(
                              this.state.Assign_date,
                              dateFormatList[0]
                            )}
                            format={dateFormatList}
                            onChange={(value) =>
                              this.handleDateChange("last_assign_date", value)
                            }
                            style={{ width: "90%" }}
                          />
                        </div>
                        <div className="col-6 mt-2">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["ma_period"]
                              }
                            </label>
                          ) : null}
                          <br />
                          <Select
                            style={{ width: "94%" }}
                            defaultValue=""
                            value={form.get_preiod}
                            className="dropdrowtype"
                            onChange={(value) =>
                              this.handleSelectChange("ma_period_id", value)
                            }
                          >
                            <Select.Option value="" disabled>
                              Please select
                            </Select.Option>
                            {this.state.get_preiod.map((item, index) => (
                              <Select.Option
                                key={index}
                                value={item.ma_period_id}
                              >
                                {item.ma_time_start}
                                {" - "}
                                {item.ma_time_end}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                        <div className="col-6 mt-2">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["plan_start_end"]
                              }
                            </label>
                          ) : null}
                          <br />
                          <RangePicker
                            onChange={(e) =>
                              this.setState({
                                plan_date: e,
                              })
                            }
                            style={{ color: "#000F9F", width: "95%" }}
                            name="date"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-3"> </div>
                    <div className="col-7">
                      <div className="row">
                        <div className="col-12">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["inform_detail"]
                              }
                            </label>
                          ) : null}
                          <br />
                          <textarea
                            style={{
                              width: "100%",
                              height: "80px",
                              fontSize: "18px",
                            }}
                            name="inform_remark"
                            onChange={this.handleInputChange}
                            className="font-thai-r"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-3"> </div>
                    <div className="col-7">
                      <div className="row">
                        <div className="col-12">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["remark"]
                              }
                            </label>
                          ) : null}
                          <br />
                          <textarea
                            style={{
                              width: "100%",
                              height: "80px",
                              fontSize: "18px",
                            }}
                            name="remark"
                            onChange={this.handleInputChange}
                            className="font-thai-r"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-3 ">
                    <div className="col-3"> </div>
                    <div className="col-7">
                      <div className="row">
                        <div className="col-6">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["object_part"]
                              }
                              <b style={{ color: "#DF4547" }}>*</b>
                            </label>
                          ) : null}
                          <Select
                            style={{ width: "100%" }}
                            className="dropdrowtype"
                            onChange={(value) =>
                              this.handleproblem("objectpart", value)
                            }
                            value={this.state.customs.select_object_path || ""}
                          >
                            <Select.Option value="" disabled>
                              Please select
                            </Select.Option>
                            {this.state.ObjectPart.map((item, index) => (
                              <Select.Option
                                key={index}
                                value={item.service_type_level_id || ""}
                              >
                                {item.service_desc}
                              </Select.Option>
                            ))}
                          </Select>
                          {this.state.valid_obj_part === false &&
                          this.state.valid === true ? (
                            <b
                              className="labeaddjob mt-4"
                              style={{ color: "#DF4547" }}
                            >
                              กรุณาเลือก Object Part
                            </b>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-6">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["service_type"]
                              }
                              <b style={{ color: "#DF4547" }}>*</b>
                            </label>
                          ) : null}
                          <Select
                            style={{ width: "100%" }}
                            defaultValue=""
                            className="dropdrowtype"
                            onChange={(value) =>
                              this.handleproblem("servicetype", value)
                            }
                            value={this.state.sel_type || ""}
                          >
                            <Select.Option value="" disabled>
                              Please select
                            </Select.Option>
                            {this.state.serviceType.map((item, index) => (
                              <Select.Option
                                key={index}
                                value={item.service_type_level_id || ""}
                              >
                                {item.service_desc}
                              </Select.Option>
                            ))}
                          </Select>
                          {this.state.valid_service_type === false &&
                          this.state.valid === true ? (
                            <b
                              className="labeaddjob mt-4"
                              style={{ color: "#DF4547" }}
                            >
                              กรุณาเลือก Service Type
                            </b>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3 ">
                    <div className="col-3"> </div>
                    <div className="col-7">
                      <div className="row">
                        <div className="col-6">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["category_type"]
                              }
                              <b style={{ color: "#DF4547" }}>*</b>
                            </label>
                          ) : null}
                          <Select
                            style={{ width: "100%" }}
                            defaultValue=""
                            className="dropdrowtype"
                            value={this.state.sel_new_type || ""}
                            onChange={(value) =>
                              this.handleproblem("new_type", value)
                            }
                          >
                            <Select.Option value="" disabled>
                              Please select
                            </Select.Option>
                            {this.state.newType.map((item, index) => (
                              <Select.Option
                                key={index}
                                value={item.service_type_level_id || ""}
                              >
                                {this.state.checkAssetType === true
                                  ? item.service_desc
                                  : item.service_LV3_name}
                                {/* {item.service_desc} */}
                              </Select.Option>
                            ))}
                          </Select>
                          {this.state.valid_new_type === false &&
                          this.state.valid === true ? (
                            <b
                              className="labeaddjob mt-4"
                              style={{ color: "#DF4547" }}
                            >
                              กรุณาเลือก Service Type
                            </b>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-6">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["sub_category"]
                              }
                              <b style={{ color: "#DF4547" }}>*</b>
                            </label>
                          ) : null}
                          <Select
                            style={{ width: "100%" }}
                            className="dropdrowtype"
                            value={this.state.sel_sub_cat || ""}
                            onChange={(value) =>
                              this.handleproblem("sub_category", value)
                            }
                          >
                            <Select.Option value="" disabled>
                              Please select
                            </Select.Option>
                            {this.state.subCategory.map((item, index) => (
                              <Select.Option
                                key={index}
                                value={item.service_type_level_id || ""}
                              >
                                {this.state.checkAssetType === true
                                  ? item.service_desc
                                  : item.service_LV4_name}
                                {/* {item.service_desc} */}
                              </Select.Option>
                            ))}
                          </Select>
                          {this.state.valid_sub_cat === false &&
                          this.state.valid === true ? (
                            <b
                              className="labeaddjob mt-4"
                              style={{ color: "#DF4547" }}
                            >
                              กรุณาเลือก Sub Category
                            </b>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3 ">
                    <div className="col-3"> </div>
                    <div className="col-7">
                      <div className="row">
                        <div className="col-3">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["sla_level"]
                              }
                            </label>
                          ) : null}
                          <Select
                            style={{ width: "100%" }}
                            defaultValue=""
                            className="dropdrowtype"
                            value={this.state.sel_sla || ""}
                            onChange={(value) =>
                              this.handleproblem("sla", value)
                            }
                          >
                            <Select.Option value="" disabled>
                              Please select
                            </Select.Option>
                            {this.state.sla_level.map((item, index) => (
                              <Select.Option
                                key={index}
                                value={item.job_sla_id}
                              >
                                {item.sla_name}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                        <div className="col-3">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["standard_day"]
                              }
                            </label>
                          ) : null}
                          <input
                            disabled
                            type="text"
                            className="inputfile"
                            style={{ width: "100%", padding: "5px" }}
                            name="inform_name"
                            value={this.state.std_day}
                          ></input>
                        </div>
                        <div className="col-3">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["standard_hour"]
                              }
                            </label>
                          ) : null}
                          <input
                            disabled
                            type="text"
                            className="inputfile"
                            style={{ width: "100%", padding: "5px" }}
                            name="inform_name"
                            value={this.state.std_hour}
                          ></input>
                        </div>
                        <div className="col-3">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["standard_minute"]
                              }
                            </label>
                          ) : null}
                          <input
                            disabled
                            type="text"
                            className="inputfile"
                            style={{ width: "100%", padding: "5px" }}
                            name="inform_name"
                            value={this.state.minute}
                          ></input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3 ">
                    <div className="col-3"> </div>
                    <div className="col-7">
                      <div className="row">
                        <div className="col-6 divhide">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["inform_name"]
                              }
                            </label>
                          ) : null}
                          <br />
                          <input
                            type="text"
                            className="inputfile"
                            style={{ width: "100%", padding: "5px" }}
                            name="inform_name"
                            onChange={this.handleInputChange}
                            // value={this.state.inform_name}
                          ></input>
                          <br />
                        </div>
                        <div className="col-12">
                          {this.state.factupdate ? (
                            <label
                              className="labeaddjob font-thai-r"
                              style={{ fontSize: "18px" }}
                            >
                              {
                                this.state.data_translate[
                                  Cookies.get("locale")
                                ]["priority"]
                              }
                            </label>
                          ) : null}
                          {/* <br /> */}
                          <Radio.Group
                            onChange={this.onChange}
                            value={this.state.Priority}
                          >
                            <Radio value={3} className="ml-5">
                              <img
                                src={ServiceApi.absoluteUrl("/icon/high.svg")}
                                style={{
                                  marginLeft: "10px",
                                  marginTop: "-10px",
                                }}
                                className="mr-2"
                              />
                            </Radio>
                            {/* <br /> */}
                            <Radio value={2} className="mt-2">
                              <img
                                src={ServiceApi.absoluteUrl("/icon/normal.svg")}
                                style={{
                                  marginLeft: "10px",
                                  marginTop: "-10px",
                                }}
                                className="mr-2"
                              />
                            </Radio>
                            {/* <br /> */}
                            <Radio value={1} className="mt-2">
                              <img
                                src={ServiceApi.absoluteUrl("/icon/low.svg")}
                                className="mr-2"
                                style={{
                                  marginLeft: "10px",
                                  marginTop: "-10px",
                                }}
                              />
                            </Radio>
                          </Radio.Group>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        Cookies.get("companyid") === "1"
                          ? "col-2 divhide"
                          : "col-2 divshow"
                      }
                      style={{ textAlign: "center" }}
                    >
                      <button
                        type="button"
                        style={{ marginTop: "60%" }}
                        className="c-blue text-underline"
                        onClick={() => this.onMoreDetail()}
                      >
                        More detail
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                this.state.statusbtn == "2"
                  ? "card mt-2 divshow"
                  : "card mt-2 divhide"
              }
              style={{ width: "95%", display: "none" }}
            >
              <div className="card-body">
                <div
                  className={
                    this.state.statusbtn == "2"
                      ? "mt-2 divshow"
                      : "mt-2  divhide"
                  }
                >
                  <div className="row mt-3">
                    <div className="col-2"> </div>

                    <div className="col-10">
                      <img
                        style={{
                          float: "left",
                          marginTop: "7px",
                          marginRight: "10px",
                        }}
                        src={ServiceApi.absoluteUrl("/icon/alert.svg")}
                      />
                      <span className="jobdetail"> MA Service </span>
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-3"> </div>

                    <div className="col-9">
                      <Checkbox
                        onChange={this.checkboxTeam}
                        checked={this.state.ckTeam}
                        style={{ fontSize: "20px", color: "#0500A3" }}
                      >
                        Team
                      </Checkbox>
                      <Checkbox
                        onChange={this.checkboxSingle}
                        checked={this.state.ckSingle}
                        style={{ fontSize: "20px", color: "#0500A3" }}
                        className="ml-5"
                      >
                        Single
                      </Checkbox>
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-3"> </div>

                    <div className="col-9">
                      <div className="row">
                        <div
                          className={
                            this.state.ckTeam == true
                              ? "divshow col-3"
                              : "divhide col-3"
                          }
                        >
                          <label className="labeaddjob mt-3">
                            MA team group <b style={{ color: "#DF4547" }}>*</b>
                          </label>
                          <br />
                          <input type="text" className="inputfile"></input>
                        </div>
                        <div
                          className={
                            this.state.ckTeam == true
                              ? "divshow col-3"
                              : "divhide col-3"
                          }
                        >
                          <label className="labeaddjob mt-3">
                            MA Team <b style={{ color: "#DF4547" }}>*</b>
                          </label>
                          <br />
                          <input type="text" className="inputfile"></input>
                        </div>
                        <div
                          className={
                            this.state.ckSingle == true
                              ? "divshow col-3"
                              : "divhide col-3"
                          }
                        >
                          <label className="labeaddjob mt-3">
                            Skill <b style={{ color: "#DF4547" }}>*</b>
                          </label>
                          <br />
                          <input type="text" className="inputfile"></input>
                        </div>
                        <div
                          className={
                            this.state.ckSingle == true
                              ? "divshow col-3"
                              : "divhide col-3"
                          }
                        >
                          <label className="labeaddjob mt-3">
                            Employee <b style={{ color: "#DF4547" }}>*</b>
                          </label>
                          <br />
                          <input type="text" className="inputfile"></input>
                        </div>
                      </div>
                      <div className="row">
                        <div
                          className={
                            this.state.ckTeam == true
                              ? "divshow col-3"
                              : "divhide col-3"
                          }
                        >
                          <label className="labeaddjob mt-3">Work date</label>
                          <br />
                          <input type="text" className="inputfile"></input>
                        </div>
                        <div
                          className={
                            this.state.ckTeam == true
                              ? "divshow col-3"
                              : "divhide col-3"
                          }
                        >
                          <label className="labeaddjob mt-3">Finish date</label>
                          <br />
                          <input type="text" className="inputfile"></input>
                        </div>
                        <div
                          className={
                            this.state.ckSingle == true
                              ? "divshow col-3"
                              : "divhide col-3"
                          }
                        >
                          <label className="labeaddjob mt-3">Work date</label>
                          <br />
                          <input type="text" className="inputfile"></input>
                        </div>
                        <div
                          className={
                            this.state.ckSingle == true
                              ? "divshow col-3"
                              : "divhide col-3"
                          }
                        >
                          <label className="labeaddjob mt-3">Finish date</label>
                          <br />
                          <input type="text" className="inputfile"></input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                this.state.statusbtn == "2"
                  ? "card mt-2 divshow"
                  : "card mt-2 divhide"
              }
              style={{ width: "95%" }}
            >
              <div className="card-body">
                <div
                  className={
                    this.state.statusbtn == "2"
                      ? "mt-2 divshow"
                      : "mt-2  divhide"
                  }
                >
                  <div className="row mt-3">
                    <div className="col-2"> </div>

                    <div className="col-10">
                      <img
                        style={{
                          float: "left",
                          marginTop: "17px",
                          marginRight: "10px",
                        }}
                        src={ServiceApi.absoluteUrl("/icon/add-folder.svg")}
                      />
                      {this.state.factupdate ? (
                        <span
                          className="jobdetail font-thai-b"
                          style={{ fontSize: "28px" }}
                        >
                          {
                            this.state.data_translate[Cookies.get("locale")][
                              "photo"
                            ]
                          }
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12 mb-5">
                      <div style={{ textAlign: "center" }} className="mt-5">
                        <div>
                          <Upload
                            action={this.state.urlpath + "mockupupload/"}
                            multiple={true}
                            listType="picture-card"
                            fileList={fileList}
                            onPreview={this.handlePreview}
                            onChange={this.handleChange}
                            onError={(e) => console.log(e)}
                            height={"20%"}
                          >
                            {fileList.length >= 8 ? null : uploadButton}
                          </Upload>
                          <Modal
                            visible={this.state.previewVisible}
                            title={this.state.previewTitle}
                            footer={null}
                            onCancel={this.handleCancel}
                          >
                            <img
                              alt="example"
                              style={{ width: "100%" }}
                              src={this.state.previewImage}
                            />
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {this.state.company_id == 2 ? (
              <div
                className={
                  this.state.statusbtn == "2"
                    ? "card mt-2 divshow"
                    : "card mt-2 divhide"
                }
                style={{ width: "95%" }}
              >
                <div className="card-body">
                  <div
                    className={
                      this.state.statusbtn == "2"
                        ? "mt-2 divshow"
                        : "mt-2  divhide"
                    }
                  >
                    <div className="row mt-3">
                      <div className="col-2"> </div>

                      <div className="col-10">
                        <img
                          style={{
                            float: "left",
                            marginTop: "17px",
                            marginRight: "10px",
                          }}
                          src={ServiceApi.absoluteUrl("/icon/add-folder.svg")}
                        />
                        {this.state.factupdate ? (
                          <span
                            className="jobdetail font-thai-b"
                            style={{ fontSize: "28px" }}
                          >
                            Other (Dynamic input)
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-12 mb-5">
                        <div style={{ textAlign: "center" }} className="mt-5">
                          {/* for white dynamic form code */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <div
          style={{ textAlign: "center" }}
          className={
            this.state.statusbtn == "2"
              ? "mt-3 mb-3 divshow"
              : "mt-3 mb-3 divhide"
          }
        >
          {this.state.checkbtn ? (
            <button
              type="button"
              className="btnbrows"
              onClick={this.handleSubmit}
            >
              <span style={{ fontSize: "16px" }}>Submit</span>
            </button>
          ) : (
            <b style={{ color: "red" }}>{this.state.status_button_workflow}</b>
          )}
        </div>
        <div>
          <Modal
            visible={this.state.modal_validate}
            title={"Error Validate"}
            footer={null}
            onCancel={this.closeModal}
          >
            {/* กรุณากรอกข้อมูลให้ครบ */}
            {this.state.error_disPlay.map((item, index) => (
              <p>{item}</p>
            ))}
          </Modal>
          {this.props.dynamicReducer.visible_dynamic === true ? (
            // {this.props.dynamicReducer.visible_dynamic === true ? (
            <Drawer
              title={
                <span className="font-mont-b font16 c-blue text-uppercase">
                  More Detail
                </span>
              }
              placement="right"
              closable={false}
              onClose={this.onClose}
              visible={this.props.dynamicReducer.visible_dynamic}
              //visible={this.props.dynamicReducer.visible_dynamic}
              width={500}
            >
              <div>
                <DynamicInput
                  obj_val="addjob"
                  page_name="addjob"
                  data_item={this.state.dataMasFormJson_Call}
                  lang={Cookies.get("locale")}
                />
              </div>
            </Drawer>
          ) : null}
        </div>
        <div style={{ height: "30px" }}></div>
      </LayoutOperation>
    );
  }
}
const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(Addjob);
